/**
 * Item service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemDetailsResponse } from './itemDetailsResponse';
import { SkuTrackShared } from './skuTrackShared';
import { TieredPriceShared } from './tieredPriceShared';
import { PackTypeResponse } from './packTypeResponse';
import { WarehouseUpdateRequestPublicPickupTitle } from './warehouseUpdateRequestPublicPickupTitle';
import { ItemEnumCharacteristicResponse } from './itemEnumCharacteristicResponse';
import { ItemStringCharacteristicResponse } from './itemStringCharacteristicResponse';
import { UnitResponse } from './unitResponse';
import { ItemNumericCharacteristicResponse } from './itemNumericCharacteristicResponse';
import { SimpleImage } from './simpleImage';
import { SkuDiscountResponse } from './skuDiscountResponse';
import { WarehouseResponse } from './warehouseResponse';


export interface SkuResponse { 
    id?: number;
    itemId?: number;
    sellerSkuId?: string;
    categoryTitle?: string;
    title?: WarehouseUpdateRequestPublicPickupTitle;
    photo?: SimpleImage;
    price?: number;
    originalPrice?: number;
    currency?: SkuResponse.CurrencyEnum;
    requestedCurrencyPrice?: number;
    requestedCurrencyOriginalPrice?: number;
    requestedCurrency?: SkuResponse.RequestedCurrencyEnum;
    weight?: number;
    sellerId?: number;
    legalSeller?: boolean;
    quantity?: number;
    minOrderSize?: number;
    maxOrderSize?: number;
    enumCharacteristics?: Array<ItemEnumCharacteristicResponse>;
    numericCharacteristics?: Array<ItemNumericCharacteristicResponse>;
    stringCharacteristics?: Array<ItemStringCharacteristicResponse>;
    packType?: PackTypeResponse;
    unit?: UnitResponse;
    item?: ItemDetailsResponse;
    warehouse?: WarehouseResponse;
    warehouseId?: number;
    skuTracks?: Array<SkuTrackShared>;
    skuDiscount?: SkuDiscountResponse;
    tieredPrices?: Array<TieredPriceShared>;
    cooldownReturnPeriod?: string;
    warrantyReturnPeriod?: string;
    digitalArtefactCount?: number;
    type?: SkuResponse.TypeEnum;
    itemBuyOptions?: { [key: string]: boolean; };
    itemTitle?: string;
}
export namespace SkuResponse {
    export type CurrencyEnum = 'RUB' | 'USD' | 'GEL' | 'KZT' | 'AZN' | 'INR' | 'SAR' | 'TMT' | 'XOF' | 'ZAR' | 'CHF' | 'NGN' | 'EGP' | 'KHR' | 'CNY';
    export const CurrencyEnum = {
        RUB: 'RUB' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        GEL: 'GEL' as CurrencyEnum,
        KZT: 'KZT' as CurrencyEnum,
        AZN: 'AZN' as CurrencyEnum,
        INR: 'INR' as CurrencyEnum,
        SAR: 'SAR' as CurrencyEnum,
        TMT: 'TMT' as CurrencyEnum,
        XOF: 'XOF' as CurrencyEnum,
        ZAR: 'ZAR' as CurrencyEnum,
        CHF: 'CHF' as CurrencyEnum,
        NGN: 'NGN' as CurrencyEnum,
        EGP: 'EGP' as CurrencyEnum,
        KHR: 'KHR' as CurrencyEnum,
        CNY: 'CNY' as CurrencyEnum
    };
    export type RequestedCurrencyEnum = 'RUB' | 'USD' | 'GEL' | 'KZT' | 'AZN' | 'INR' | 'SAR' | 'TMT' | 'XOF' | 'ZAR' | 'CHF' | 'NGN' | 'EGP' | 'KHR' | 'CNY';
    export const RequestedCurrencyEnum = {
        RUB: 'RUB' as RequestedCurrencyEnum,
        USD: 'USD' as RequestedCurrencyEnum,
        GEL: 'GEL' as RequestedCurrencyEnum,
        KZT: 'KZT' as RequestedCurrencyEnum,
        AZN: 'AZN' as RequestedCurrencyEnum,
        INR: 'INR' as RequestedCurrencyEnum,
        SAR: 'SAR' as RequestedCurrencyEnum,
        TMT: 'TMT' as RequestedCurrencyEnum,
        XOF: 'XOF' as RequestedCurrencyEnum,
        ZAR: 'ZAR' as RequestedCurrencyEnum,
        CHF: 'CHF' as RequestedCurrencyEnum,
        NGN: 'NGN' as RequestedCurrencyEnum,
        EGP: 'EGP' as RequestedCurrencyEnum,
        KHR: 'KHR' as RequestedCurrencyEnum,
        CNY: 'CNY' as RequestedCurrencyEnum
    };
    export type TypeEnum = 'PHYSICAL' | 'DIGITAL' | 'FINANCIAL_ITEM' | 'TENDER' | 'DIGITAL_CALENDAR' | 'INTERVIEW';
    export const TypeEnum = {
        PHYSICAL: 'PHYSICAL' as TypeEnum,
        DIGITAL: 'DIGITAL' as TypeEnum,
        FINANCIAL_ITEM: 'FINANCIAL_ITEM' as TypeEnum,
        TENDER: 'TENDER' as TypeEnum,
        DIGITAL_CALENDAR: 'DIGITAL_CALENDAR' as TypeEnum,
        INTERVIEW: 'INTERVIEW' as TypeEnum
    };
}


